import styled from 'styled-components';

const StyledWrapper = styled.div`
	transition: opacity 0.3s ease;

	&.apps-enter {
		opacity: 0;
	}

	&.apps-enter-active,
	&.apps-enter-done,
	&.apps-exit {
		opacity: 1;
	}

	&.apps-exit-active {
		opacity: 0;
	}
`;

const StyledContainer = styled.div`
	padding: 20px 20px 0;
	transition: opacity 0.3s;
	opacity: 0;

	&.start-enter {
		opacity: 0;
	}

	&.start-enter-active,
	&.start-enter-done,
	&.start-exit {
		opacity: 1;
	}

	&.start-exit-active {
		opacity: 0;
	}
`;

export { StyledContainer, StyledWrapper };
